<mat-form-field appearance="outline" matRipple (click)="open($event)">
  <mat-label [ngClass]="{active:isActive}">Filter</mat-label>
  <mat-icon
    [ngClass]="{active:isActive}"
    fontSet="material-symbols-outlined"
    matPrefix
    >filter_alt</mat-icon
  >
  <input matInput readonly style="display: none" />
</mat-form-field>
